import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_API_URL } from "../Constant";

export const UserMaintenanceSlice = createSlice({
  name: "UserMaintenanceData",
  initialState: {
    rolesData: [],
    permissionsData: [],
    coursesData: [],
    error: false,
    loader: false,
  },
  reducers: {
    setRolesData: (state, action) => {
      state.rolesData = action.payload;
    },
    setPermissionsData: (state, action) => {
      state.permissionsData = action.payload;
    },
    setCoursesData: (state, action) => {
      state.permissionsData = action.payload;
    },
    setError: (state) => {
      state.error = true;
    },
    setLoader: (state, action) => {
      state.loader = action.payload;
    },
  },
});

export const {
  setRolesData,
  setPermissionsData,
  setCoursesData,
  setError,
  setLoader,
} = UserMaintenanceSlice.actions;
export default UserMaintenanceSlice.reducer;

export function getRolesData() {
  return async (dispatch) => {
    dispatch(setLoader(true));
    await axios
      .get(`${BASE_API_URL}/api/getRolesData`, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        dispatch(setRolesData(res.data));
        dispatch(setLoader(false));
        dispatch(setError([]));
        console.info("get list res.data", res.data);
      })
      .catch((err) => {
        console.error("get list error is", err);
        dispatch(setError(err));
      });
  };
}

export function addRolesData(roleFields) {
  return async (dispatch) => {
    dispatch(setLoader(true));
    await axios
      .post(`${BASE_API_URL}/api/addRolesData`, roleFields, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        dispatch(setLoader(false));
        dispatch(getRolesData());
        dispatch(setError([]));
        console.info("get list res.data", res.data);
      })
      .catch((err) => {
        console.error("get list error is", err);
        dispatch(setError(err));
      });
  };
}

export function updateRolesData(roleFields) {
  return async (dispatch) => {
    dispatch(setLoader(true));
    await axios
      .post(`${BASE_API_URL}/api/updateRolesData`, roleFields, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        dispatch(setLoader(false));
        dispatch(getRolesData());
        console.info("get list res.data", res.data);
      })
      .catch((err) => {
        console.error("get list error is", err);
        dispatch(setError(err));
      });
  };
}

export function deleteRolesData(roleFields) {
  return async (dispatch) => {
    dispatch(setLoader(true));
    await axios
      .delete(`${BASE_API_URL}/api/deleteRolesData/${roleFields?.id}`, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        dispatch(setLoader(false));
        dispatch(getRolesData());
        dispatch(setError([]));
        console.info("get list res.data", res.data);
      })
      .catch((err) => {
        console.error("get list error is", err);
        dispatch(setError(err));
      });
  };
}

export function getPermissionsData() {
  return async (dispatch) => {
    dispatch(setLoader(true));
    await axios
      .get(`${BASE_API_URL}/api/getPermissionsData`, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        dispatch(setPermissionsData(res.data));
        dispatch(setLoader(false));
        dispatch(setError([]));
        console.info("get list res.data", res.data);
      })
      .catch((err) => {
        console.error("get list error is", err);
        dispatch(setError(err));
      });
  };
}

export function addPermissionsData(permissionsFields) {
  return async (dispatch) => {
    dispatch(setLoader(true));
    await axios
      .post(`${BASE_API_URL}/api/addPermissionsData`, permissionsFields, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        dispatch(setLoader(false));
        dispatch(getPermissionsData());
        dispatch(setError([]));
        console.info("get list res.data", res.data);
      })
      .catch((err) => {
        console.error("get list error is", err);
        dispatch(setError(err));
      });
  };
}

export function updatePermissionsData(permissionsFields) {
  return async (dispatch) => {
    dispatch(setLoader(true));
    await axios
      .post(`${BASE_API_URL}/api/updatePermissionsData`, permissionsFields, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        dispatch(setLoader(false));
        dispatch(getPermissionsData());
        console.info("get list res.data", res.data);
      })
      .catch((err) => {
        console.error("get list error is", err);
        dispatch(setError(err));
      });
  };
}

export function deletePermissionsData(permissionsFields) {
  return async (dispatch) => {
    dispatch(setLoader(true));
    await axios
      .delete(
        `${BASE_API_URL}/api/deletePermissionsData/${permissionsFields?.id}`,
        {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        },
      )
      .then((res) => {
        dispatch(setLoader(false));
        dispatch(getPermissionsData());
        dispatch(setError([]));
        console.info("get list res.data", res.data);
      })
      .catch((err) => {
        console.error("get list error is", err);
        dispatch(setError(err));
      });
  };
}

export function getCoursesData() {
  return async (dispatch) => {
    dispatch(setLoader(true));
    await axios
      .get(`${BASE_API_URL}/api/getCoursesData`, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        dispatch(setCoursesData(res.data));
        dispatch(setLoader(false));
        dispatch(setError([]));
        console.info("get list res.data", res.data);
      })
      .catch((err) => {
        console.error("get list error is", err);
        dispatch(setError(err));
      });
  };
}
